import { APIClient } from "./axiosClient";

const api = new APIClient();

const path = "/agency";

const agencyApi = {
  agencyList(params: any): Promise<any> {
    const url = `${path}`;
    return api.get(url, params);
  },

  getAgencyDetail(id: string | number, params: any = {}) : Promise<any>  {
    const url = `${path}/${id}`;
    return api.get(url, params)
  },

  createAgency(params: any) {
    return api.post(path, params);
  },

  updateAgency(id: any, params: any) {
    return api.put(`${path}/${id}`, params);
  },

  deleteAgency(id: any) {
    return api.delete(`${path}/${id}`);
  },

  agencyCampaignList(params: any): Promise<any> {
    const url = `${path}/campaigns`;
    return api.get(url, params);
  },

  getAgencyCampaignDetail(id: string | number, params: any = {}) : Promise<any>  {
    const url = `${path}/campaigns/${id}`;
    return api.get(url, params)
  },

  createAgencyCampaign(params: any) {
    const url = `${path}/campaigns`;
    return api.post(url, params);
  },

  updateAgencyCampaign(id: any, params: any) {
    const url = `${path}/campaigns/${id}`;
    return api.put(url, params);
  },

  deleteAgencyCampaign(id: any) {
    const url = `${path}/campaigns/${id}`;
    return api.delete(url);
  },

  agencyEventStrackingLogs(params: any): Promise<any> {
    const url = `${path}/installs`;
    return api.get(url, params);
  },
};

export default agencyApi;
